<template>
  <div v-if="list" class="deposit-campaign" ref="scrollContainer">
    <div class="deposit-campaign__table">
      <div class="deposit-campaign__table-row deposit-campaign__table-row--head hide-xs">
        <div class="deposit-campaign__table-campaign">
          {{ $t('deposit_campaign.campaign') }}
        </div>
        <div class="deposit-campaign__table-rest">
          {{ $t('deposit_campaign.remainder') }}
        </div>
        <div class="deposit-campaign__table-amount">
          {{ $t('deposit_campaign.add_amount') }}
        </div>
      </div>
      <div class="deposit-campaign__table-row">
        <div class="deposit-campaign__table-campaign">
          <label class="input__item-checkbox">
            <input type="checkbox" value="'all'" v-model="chooseAll" />
            <span class="input__item-checkbox__check">
              <img src="@/assets/icons/icon-done.svg" />
            </span>
            <span class="input__item-checkbox__info">
              <span class="input__item-checkbox__title">
                {{ $t('deposit_campaign.select_all') }}
              </span>
            </span>
          </label>
        </div>
      </div>
      <div v-for="item in visibleItems" :key="item.id" class="deposit-campaign__table-row">
        <div class="deposit-campaign__table-campaign">
          <div class="deposit-campaign__caption hide-lg hide-md hide-sm">
            {{ $t('deposit_campaign.campaign') }}
          </div>
          <label class="input__item-checkbox">
            <input
              type="checkbox"
              :value="item.id"
              @change="changedSelectedCampaigns"
              v-model="chooseCampaign"
            />
            <span class="input__item-checkbox__check">
              <img src="@/assets/icons/icon-done.svg" />
            </span>
            <span class="input__item-checkbox__info">
              <span class="input__item-checkbox__title">
                {{ item.id }}
              </span>
              <span class="input__item-checkbox__desc">
                {{ item.name }}
              </span>
            </span>
          </label>
        </div>
        <div class="deposit-campaign__table-rest">
          <div class="deposit-campaign__caption hide-lg hide-md hide-sm">
            {{ $t('deposit_campaign.remainder') }}
          </div>
          <div class="deposit-campaign__table-rest-text">
            {{ numberWithSpacesCeil(item.total_limit) }} {{ $t('currency.currency_symbol') }}
          </div>
        </div>
        <div class="deposit-campaign__table-amount">
          <div class="deposit-campaign__caption hide-lg hide-md hide-sm">
            {{ $t('deposit_campaign.add_amount') }}
          </div>
          <DepositAmount :campaign-id="item.id" :currency="currency" :addAccount="addAccount" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DepositAmount from '@/components/ad/DepositAmount';
import numberWithSpaces from '@/mixin/numberWithSpaces';

export default {
  name: 'DepositCampaign',
  components: {
    DepositAmount,
  },
  mixins: [numberWithSpaces],
  props: {
    list: {
      type: Array,
      default: null,
    },
    currency: {
      type: String,
      default: null,
    },
    addAccount: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chooseAll: false,
      chooseCampaign: [],
      currency_symbols: {
        RUB: '₽',
        USD: '$',
        EUR: '€',
        PLN: 'zł',
      },
      visibleItems: [],
      itemsPerPage: 100,
      currentPage: 1,
    };
  },
  watch: {
    list: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.resetPagination();
          this.loadMoreItems();
        }
      },
    },
    chooseAll(val) {
      if (val) {
        if (this.list && this.list.length) {
          this.list.forEach((el) => {
            this.chooseCampaign.push(el.id);
          });
        }
      } else {
        this.chooseCampaign = [];
      }
      this.$store.commit('Balance/setData', { label: 'chooseCampaign', data: this.chooseCampaign });
    },
  },
  methods: {
    resetPagination() {
      this.currentPage = 1;
      this.visibleItems = [];
    },
    loadMoreItems() {
      if (!this.list || this.visibleItems.length >= this.list.length) return;

      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      const newItems = this.list.slice(startIndex, endIndex);

      this.visibleItems = [...this.visibleItems, ...newItems];
      this.currentPage++;
    },
    changedSelectedCampaigns() {
      this.$store.commit('Balance/setData', { label: 'chooseCampaign', data: this.chooseCampaign });
    },
    resetChosenCampaigns() {
      this.chooseAll = false;
    },
    handleScroll() {
      const container = this.$el;
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const offsetHeight = container.offsetHeight;

      if (scrollTop + offsetHeight >= scrollHeight - 10) {
        this.loadMoreItems();
      }
    },
  },
  mounted() {
    // Добавляем обработчик события прокрутки
    const container = this.$el; // или укажите конкретный контейнер
    container.addEventListener('scroll', this.handleScroll);

    // Инициализация начальных элементов
    this.loadMoreItems();
  },
  beforeDestroy() {
    // Удаляем обработчик события прокрутки
    const container = this.$el; // или укажите конкретный контейнер
    container.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';
.deposit-campaign {
  width: 100%;

  &__table-rest-text {
    margin-top: 1.5rem;
  }

  &__caption {
    min-height: 2.4rem;
    max-height: 2.4rem;
    line-height: 1;
  }

  &__table-row {
    display: grid;
    grid-template-columns: 1fr 7rem 20rem;
    gap: 2.4rem;
    min-height: 8rem;

    @include below(769px) {
      grid-template-columns: 1fr 7rem 16rem;
    }

    @include below(461px) {
      grid-template-columns: 1fr;
      margin-top: 2rem;

      &:nth-child(2) {
        margin: 0;
      }
    }
  }

  &__name {
    margin-bottom: 2rem;

    img {
      width: 13rem;
    }
  }

  &__table {
    &-row {
      &:nth-of-type(2) {
        min-height: 5rem;
      }

      &--head {
        font-size: 1.6rem;
        line-height: 1.9rem;
        color: #aaaaaa;
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
        padding-bottom: 1.3rem;
        min-height: auto;
        margin-bottom: 2rem;

        .deposit-campaign__table-campaign {
          padding-left: 3rem;
        }
      }
    }

    &-campaign {
      width: 100%;
    }

    &-rest {
      font-size: 1.6rem;
      line-height: 1.9rem;
      text-align: right;

      span {
        color: #aaaaaa;
      }
    }
  }

  .input__item-checkbox {
    align-items: flex-start;
  }
}

@include below(769px) {
  .deposit-campaign {
    width: 100%;
  }
  .deposit-campaign__caption {
    margin-bottom: 5px;
    color: #aaaaaa;
  }
  .deposit-campaign__table-row {
    gap: 2rem;

    > div {
      text-align: left;
      padding: 0;
    }
  }

  .deposit-campaign__table-campaign {
    margin-bottom: 10px;
    max-width: 100%;
    width: 100%;
  }
  .deposit-campaign__table-rest-text {
    height: 28px;
    display: flex;
    align-items: center;
  }
}

@include below(461px) {
  .deposit-campaign__table-campaign {
    max-width: 100%;
  }

  .deposit-campaign__table-row {
    flex-wrap: wrap;
  }
}
</style>
